import { useEffect, useState, useCallback } from "react";
import api from "./api";

export function formatCents(cents, currency = "AUD") {
  const v = (cents || 0) / 100;
  return new Intl.NumberFormat(undefined, {
    style: "currency", currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(v);
}

export function centsToShort(cents) {
  const v = Math.abs((cents || 0) / 100);
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(1)}k`;
  return `$${v.toFixed(0)}`;
}

export function useOverview() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await api.get("/money/overview"); setData(r.data); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return { data, loading, reload: load };
}

export function useCategories() {
  const [cats, setCats] = useState([]);
  const load = useCallback(async () => {
    const r = await api.get("/money/categories"); setCats(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);
  return { categories: cats, reload: load };
}

export function useAccounts() {
  const [accs, setAccs] = useState([]);
  const load = useCallback(async () => {
    const r = await api.get("/money/accounts"); setAccs(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);
  return { accounts: accs, reload: load };
}
